import $ from 'jquery';
import { commonMiddleware, protectRoute } from '../middleware';
import ReactDOM from 'react-dom';
import React from 'react';
import { ProjectsPage } from '~src/components/Projects';
import { trackPageView } from '~src/tracking';
import { initHomeExperience } from '~src/home';
import { initSidebarProfile } from '../../sidebar-profile';

export const projectsRoute = async () => {
  document.title = 'Progetti | Giotto';

  await protectRoute();
  await commonMiddleware();
  // Ensure the window is at the top before rendering to avoid any
  // initial scroll/jump visual effect on mount.
  try {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  } catch (e) {
    // no-op in non-browser contexts
  }
  $('#navbar-private').hide();
  $('#navbar-canvas').hide();
  $('.logo').hide();

  $('#route-projects').show();
  // Ensure body can scroll on Projects (window scroll is used by InfiniteScroll)
  $('body').removeClass('dashboard dashboard-sidebar-open');
  initHomeExperience();
  // Ensure profile data is bound to the visible route sidebar
  initSidebarProfile();
  const domContainer = document.querySelector('#projects-root');
  ReactDOM.render(React.createElement(ProjectsPage), domContainer);
  trackPageView('Projects');
};
